var myApp = angular.module('Order4meClient', [ 'ui.bootstrap', 'ui.router', 'ngAnimate', 'ngSanitize', 'ngCookies',
    'pascalprecht.translate', 'angular.backtop', 'ngStorage', 'pubnub.angular.service', 'angularCSS',
    'ngGeolocation', 'textAngular', 'Order4meBase', 'ngRaven', 'ngIntlTelInput', 'AngularPrint', 'ngSanitize'
]);
